module.exports = __webpack_public_path__ + "static/media/folderopen.30723a10.svg";